import React from 'react';
import { useParams } from 'react-router-dom';
import { ApolloError, useQuery } from '@apollo/client';
import { FindRessourceByTypeIdQuery } from '../../../graphql/generated/graphql';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import Card from '../../../components/molecules/Card';
import { excerpt } from '../../../helpers/text/excerpt';
import useStyle from './RessourcesChallengesRessources.style';
import { QUERY_RESSOURCES_BY_TYPE } from '../../../graphql/query/ressource/queryRessourcesByType';
import { getRessourceCardLinks } from '../../../helpers/transformApiResponse/ressources';
import { BackButton } from 'components/molecules/Buttons/BackButton';

export const RessourcesChallengesRessources = () => {
  const { id } = useParams<{ id: string }>();
  const classes = useStyle();

  const { data, loading, error } = useQuery<FindRessourceByTypeIdQuery>(
    QUERY_RESSOURCES_BY_TYPE,
    {
      variables: { id }
    }
  );

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new ApolloError({
            extraInfo: error,
            errorMessage: 'error query FindRessourceByTypeIdQuery'
          })
        }
        text="error query FindRessourceByTypeIdQuery"
      />
    );

  return (
    <>
      <BackButton text="Retour aux thèmes" />
      <div className={classes.cardContainer}>
        {data.findRessourceByTypeId.map((ressource, index) => {
          const cardLinks = getRessourceCardLinks(ressource);
          return (
            <div className={classes.card} key={index}>
              <Card
                key={index}
                title={ressource.name}
                subTitle={ressource.subtitle}
                desc={excerpt(ressource.desc, 140)}
                links={cardLinks}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};
